import { MENTION_PATTERN } from '@novachat/shared';
/**
 * People are typed and read as "@Ad Soyad" but sent as `<@id>`, so renames never break a mention.
 * Longer names first: "@Ali Veli" must not become a mention of "Ali".
 */
export function toWire(text, people) {
    const byLength = [...people].sort((a, b) => b.name.length - a.name.length);
    let out = text;
    for (const person of byLength) {
        const name = person.name.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
        out = out.replace(new RegExp(`(^|[^\\p{L}\\p{N}_])@${name}(?![\\p{L}\\p{N}_])`, 'gu'), `$1<@${person.id}>`);
    }
    return out;
}
const nameOf = (id, people) => people.find((p) => p.id === id.toLowerCase())?.name ?? 'bilinmeyen';
/** Back to what the user typed, for editing. */
export const toEditable = (content, people) => content.replace(MENTION_PATTERN, (_, id) => `@${nameOf(id, people)}`);
/** One-line previews (reply quotes, pins, notifications): mentions as names, markdown left as is. */
export const plainText = toEditable;
/** The "@yazılan" being typed right before the caret, if any. */
export function mentionQuery(text, caret) {
    const before = text.slice(0, caret);
    const match = /(^|\s)@([\p{L}\p{N}_]*(?: [\p{L}\p{N}_]*)?)$/u.exec(before);
    if (!match)
        return null;
    return { start: caret - match[2].length - 1, query: match[2] };
}
//# sourceMappingURL=mentions.js.map